import axios from 'axios';
import consts from '../consts';
import { initialize } from 'redux-form';
import {
    setErroAPI,
    setSuccess
} from '../common/toast/toast';

const API = `${consts.API_URL}/planoConta`;

export const PLANO_CONTA_MODO_TELA =
    'PLANO_CONTA_MODO_TELA';

export const PLANO_CONTA_SET_AGUARDANDO =
    'PLANO_CONTA_SET_AGUARDANDO';

export const PLANO_CONTA_LISTADO =
    'PLANO_CONTA_LISTADO';

const normalizarInteiro = (valor, padrao = null) => {
    if (
        valor === null ||
        valor === undefined ||
        valor === ''
    ) {
        return padrao;
    }

    const numero = parseInt(valor, 10);

    return Number.isInteger(numero)
        ? numero
        : padrao;
};

const normalizarRegistro = registro => ({
    ...registro,

    id_plano_conta_pai:
        normalizarInteiro(
            registro.id_plano_conta_pai
        ),

    ordem: normalizarInteiro(
        registro.ordem,
        0
    ),

    aceita_lancamento:
        registro.aceita_lancamento === true ||
        registro.aceita_lancamento === 1 ||
        registro.aceita_lancamento === '1' ||
        registro.aceita_lancamento === 'true'
});

export function setModoTela(modo, registro = {}) {
    return {
        type: PLANO_CONTA_MODO_TELA,
        payload: {
            modo,
            registro
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: PLANO_CONTA_SET_AGUARDANDO,
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize(
            'planoContaForm',
            registro
        )
    ];
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const resp = await axios.get(API);

            dispatch({
                type: PLANO_CONTA_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const registroNormalizado =
                normalizarRegistro(registro);

            const request = registroNormalizado.id
                ? axios.put(
                    API,
                    registroNormalizado
                )
                : axios.post(
                    API,
                    registroNormalizado
                );

            await request;

            setSuccess(
                'Operação realizada com sucesso.'
            );

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess(
                'Operação realizada com sucesso.'
            );

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}